import React, { useCallback, useEffect, useState } from "react";
import { getMovements } from "../api";
import { errMsg, fmtMoney, fmtDateTime, MOV_TYPE } from "../utils";

/** Movimientos del cupo: tarjetas de saldo + libro (solo lectura). */
export default function Movimientos({ me }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setData(null);
    setError("");
    try {
      setData(await getMovements());
    } catch (e) {
      setError(errMsg(e, "No se pudieron cargar los movimientos."));
      setData({});
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (data === null) {
    return <div className="center"><div className="spinner" /></div>;
  }

  const movements = Array.isArray(data)
    ? data
    : data.movements || data.items || data.results || [];
  const balance = data.credit_balance ?? me?.credit_balance;
  const committed = data.committed_active ?? me?.committed_active;
  const available = data.available ?? me?.available;

  return (
    <>
      <div className="section">Movimientos del cupo</div>

      <div className="mov-cards">
        <div className="mov-card">
          <div className="lbl">Saldo del cupo</div>
          <div className="val">{fmtMoney(balance)}</div>
        </div>
        <div className="mov-card">
          <div className="lbl">Apartado en cupones</div>
          <div className="val">{fmtMoney(committed)}</div>
        </div>
        <div className="mov-card hi">
          <div className="lbl">Disponible</div>
          <div className="val">{me && !me.uses_credit ? "Sin tope" : fmtMoney(available)}</div>
        </div>
      </div>

      {error && <div className="banner err">{error}</div>}

      {!error && movements.length === 0 ? (
        <div className="card"><div className="empty">Sin movimientos registrados.</div></div>
      ) : (
        movements.length > 0 && (
          <div className="card table-card">
            <div className="table-wrap">
              <table className="tbl">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Tipo</th>
                    <th>Detalle</th>
                    <th className="num">Valor</th>
                    <th className="num">Saldo después</th>
                  </tr>
                </thead>
                <tbody>
                  {movements.map((m, i) => {
                    const amount = Number(m.amount || 0);
                    const detail = [m.description, m.reference].filter(Boolean).join(" · ");
                    return (
                      <tr key={m.id || i}>
                        <td>{fmtDateTime(m.created_at)}</td>
                        <td>
                          <span className="chip mv">{MOV_TYPE[m.movement_type] || m.movement_type}</span>
                        </td>
                        <td className="detail">{detail || "—"}</td>
                        <td className={`num ${amount >= 0 ? "pos" : "neg"}`}>
                          {amount >= 0 ? "+" : "−"}{fmtMoney(Math.abs(amount))}
                        </td>
                        <td className="num"><b>{fmtMoney(m.balance_after)}</b></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )
      )}
    </>
  );
}
